// extracted by mini-css-extract-plugin
export default {"group-header":"BO6pOo","groupHeader":"BO6pOo","check":"TT_ZYw","japan":"lEIprP","minus":"wtsUmy"};